/**
 * The rules a new password has to meet, in the order they are shown.
 *
 * One list for every sign-up form, so a centre owner and a solo therapist are
 * held to the same bar and see the same checklist.
 */
export const PASSWORD_RULES = ["length", "uppercase", "lowercase", "number", "special"] as const;

export type PasswordRule = (typeof PASSWORD_RULES)[number];

export function validatePassword(pwd: string): Record<PasswordRule, boolean> {
  return {
    length: pwd.length >= 6,
    uppercase: /[A-Z]/.test(pwd),
    lowercase: /[a-z]/.test(pwd),
    number: /[0-9]/.test(pwd),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
  };
}

export function isPasswordValid(pwd: string): boolean {
  return Object.values(validatePassword(pwd)).every(Boolean);
}
